
export default {
  routeDetails: {
    routeDetails: 'Route Details',
    warnings: 'Warnings',
    routes: 'Routes',
    route: 'Route',
    segments: 'Segments',
    segment: 'Segment',
    instructions: 'Instructions',
    instruction: 'Instruction',
    name: 'Name',
    selectRoute: 'Select this route',
    selectedRoute: 'Selected route',
    gotoSegment: 'Go to segment',
    warningCodes: {
      1: 'There may be restrictions on some roads',
      2: 'There are tollways along the route',
      3: 'There are skipped segments along the route. Durations and accessibility may not be correct',
      4: 'At least one extra info requested but it is not available',
    },
    routeOpacity: 'Route opacity'
  }
}